import React, { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Button, IconButton, TextField, Box, Typography, InputAdornment, Tooltip } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUINoRecordComponent } from '../../atomic/atoms';
import { SCUIBreadCrumb, SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { SCUIButton } from '../../atomic/atoms';
import { OmnichannelQuery } from '../../services/query';
import { useTranslation } from 'react-i18next';
import RoomIcon from '@mui/icons-material/Room';
import TuneIcon from '@mui/icons-material/Tune';
import SearchIcon from '@mui/icons-material/Search';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { StoreReturnFilter } from './components';
import { SR } from './storeReturn.classes';
export const StoreReturn: FC<any> = () => {
    const onDrawerOpen = () => setDrawerOpen(true);
    const onDrawerClose = () => setDrawerOpen(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { t } = useTranslation();
    const [storeCity, setStoreCity] = React.useState<any>();
    const [searchedStore, setSearchedStore] = React.useState('');
    const [storeReturnList, setStoreReturnList] = useState<any>();
    const [searchedReturnList, setSearchedReturnList] = useState<any>();

    const getStoreList = () => {
        OmnichannelQuery.GetStoreCity()
            .then((res: any) => {
                if (res.data) {
                    setStoreCity(res.data);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    const requestSearchStoreHandle = (searchedVal: any) => {
        setSearchedStore(searchedVal.target.value);
        let filteredStores = searchedReturnList.filter(
            (o: any) => o.storename.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        setStoreReturnList(filteredStores);
    };
    useEffect(() => {
        getStoreList();
    }, []);

    const listele = (cityId: number, countyId: number) => {
        let params: any = {};
        params.CityId = cityId;
        params.CountyId = countyId !== 0 ? countyId : '';
        OmnichannelQuery.GetStore(params)
            .then((res: any) => {
                if (res.data) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            id: item.storeId || '-',
                            city: item.storeCityName || '-',
                            county: item.storeCountyName || '',
                            storename: item.storeName || '',
                            lattitude: item.lattitude,
                            longitude: item.longitude,
                        };
                    });
                    setStoreReturnList(parseData);
                    setSearchedReturnList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90, hide: true },
        {
            field: 'city',
            headerName: t('general.cityName'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={SR.cellCity} data-city={params.row.city}>
                    {params.row.city}
                </span>
            ),
        },
        {
            field: 'county',
            headerName: t('general.countyName'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={SR.cellCounty} data-county={params.row.county}>
                    {params.row.county}
                </span>
            ),
        },
        {
            field: 'storename',
            headerName: t('general.storeName'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={SR.cellStoreName} data-store-name={params.row.storename}>
                    {params.row.storename}
                </span>
            ),
        },
        {
            field: 'detay',
            headerName: t('general.location'),
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    window.open(
                        'https://maps.google.com/maps?q=loc:' + params.row.lattitude + ',' + params.row.longitude,
                        '_blank',
                        'noopener,noreferrer'
                    );
                };
                return (
                    <div className={SR.cellLocation}>
                        <Button onClick={onclick} className={SR.btnOpenLocation} data-store-id={params.row.id}>
                            <RoomIcon className="svg_icons" />
                        </Button>
                    </div>
                );
            },
        },
    ];

    return (
        <SCUIContent className={SR.page}>
            <Grid direction="row" justifyContent={'center'} className={SR.root}>
                <SCUIGeneralDrawer
                    width={'300px'}
                    open={drawerOpen}
                    onClose={(event: any, reason: any) => {
                        if (reason === 'backdropClick') {
                            setDrawerOpen(false);
                        }
                    }}
                >
                    <Box className={SR.filterDrawer}>
                        <StoreReturnFilter cities={storeCity} onClose={onDrawerClose} listele={listele} />
                    </Box>
                </SCUIGeneralDrawer>
                <Box className={SR.breadcrumb}>
                    <SCUIBreadCrumb title={t('general.marketplaceReturnStoreList')} componentLink={'StoreReturn'} />
                </Box>
                {storeReturnList ? (
                    <Grid container direction="row" spacing={2} className={SR.listResults}>
                        <Grid
                            size={{ xs: 12, sm: 12, md: 6, lg: 9, xl: 9 }}
                            className={SR.listHeader}
                            sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                            <StorefrontIcon
                                className={SR.listHeaderIcon}
                                sx={{ fontSize: 18, color: 'primary.main' }}
                            />
                            <Typography
                                fontWeight={700}
                                fontSize={14}
                                color="text.primary"
                                className={SR.listHeaderTitle}
                            >
                                Listelenen Mağazalar
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 10, lg: 2, md: 4, xl: 2 }} className={SR.searchBox}>
                            <TextField
                                label={t('general.storeName')}
                                value={searchedStore}
                                onChange={(searchVal) => requestSearchStoreHandle(searchVal)}
                                fullWidth
                                size="small"
                                className={SR.inputSearchStore}
                                slotProps={{
                                    input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon sx={{ fontSize: 17, color: 'grey.400' }} />
                                            </InputAdornment>
                                        ),
                                    },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: 2,
                                        fontSize: 13,
                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 1.5 },
                                    },
                                    '& .MuiInputLabel-root': { fontSize: 13 },
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1, md: 1, lg: 0.5, xl: 0.5 }} className={SR.openFilterBox}>
                            <Tooltip title={t('general.filter')} placement="top" arrow>
                                <IconButton
                                    className={SR.btnOpenFilter}
                                    sx={{
                                        width: 37,
                                        height: 37,
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: 'primary.main',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                            backgroundColor: 'primary.main',
                                            '& .MuiSvgIcon-root': { color: 'white' },
                                        },
                                    }}
                                    onClick={() => onDrawerOpen()}
                                >
                                    <TuneIcon
                                        className={SR.btnOpenFilterIcon}
                                        sx={{ fontSize: 18, color: 'primary.main', transition: 'color 0.2s ease' }}
                                    />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Box className={SR.grid} sx={{ width: '100%' }}>
                            <SCUICustomDataGrid rows={storeReturnList} columns={columns} />
                        </Box>
                    </Grid>
                ) : (
                    <Box
                        className={SR.emptyState}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 2,
                        }}
                    >
                        <Box className={SR.emptyStateNoRecord}>
                            <SCUINoRecordComponent />
                        </Box>

                        <SCUIButton
                            text={t('general.filter')}
                            type="primary"
                            sizeType="default"
                            size={'m'}
                            className={SR.btnEmptyFilter}
                            onClick={() => onDrawerOpen()}
                        />
                    </Box>
                )}
            </Grid>
        </SCUIContent>
    );
};
